<template>
  <Container type="card-full">
       <div class="view-container">
            <div class="view-box">
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">评审人姓名</div>
                        <div class="view-value">{{reviewInfo.pexpertname}}</div>
                    </div>
                    <div class="view-field">
                        <div class="view-label">修改类型</div>
                        <div class="view-value">{{+reviewInfo.pexchangetype === 1?"初审":"评分"}}</div>
                    </div>
                </div>
                <div class="view-row">
                    <div class="view-field">
                        <div class="view-label">申请理由</div>
                        <div class="view-content">{{reviewInfo.pexchangereason}}</div>
                    </div>
                </div>
                <div class="view-row"  v-if="+type === 2">
                    <div class="view-field">
                        <div class="view-label">是否同意</div>
                        <div class="view-value">
                            {{reviewInfo.pexchangestatus === 2?"同意":"驳回"}}
                        </div>
                    </div>
                </div>
                <div class="view-row"  v-if="+type === 2">
                    <div class="view-field">
                        <div class="view-label">审批意见</div>
                        <div class="view-content">
                            {{reviewInfo.pexchangeopinion}}
                        </div>
                    </div>
                </div>
                <div class="view-row" v-if="+type === 1">
                    <div class="view-field">
                        <div class="view-label">是否同意</div>
                        <div class="view-value">
                            <el-radio-group v-model="reviewInfo.pexchangestatus">
                            <el-radio :label="2">同意</el-radio>
                            <el-radio :label="3">驳回</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <el-form :model="reviewInfo" ref="ruleForm" label-position="right" class="mainfrom" v-if="+type === 1">
                        <div class="content">
                            <el-form-item label="审批意见"  prop="pexchangeopinion" verify  style="width:60%;">
                                <el-input show-word-limit :maxlength="1000" type="textarea" :rows="5"
                                        v-model.trim="reviewInfo.pexchangeopinion"></el-input>
                            </el-form-item>
                        </div>
                        <div class="view-row">
                            <div class="view-field">
                                <div class="view-label"></div>
                                <div class="view-value">
                                    <el-button type='primary' @click="submitReview">提交</el-button>
                                </div>
                            </div>
                        </div>
                </el-form>
            </div>
       </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  export default {
    name: "projectReviewScore",
    data () {
      return {
        type:"",
        pexchangeid:{},
        reviewInfo:{}
      }
    },
    created () {
    },
    async activated() {
      this.init()
      this.getReviewInfoByid()
      
    },
    async mounted () {
    },
    watch: {
    },
    filters: {
    },
    computed: {
    },
    methods: {
        init(){
            this.pexchangeid = this.$route.params.pexchangeid
            this.type = this.$route.params.type
        },
        async getReviewInfoByid(){
            let res = await request({
                method: 'get',
                url: 'xmgl/project/getReviewInfoByid',
                params: {pexchangeid: this.pexchangeid}
            })
            this.reviewInfo = res
        },
        async submitReview(){
            let model = {}
            model.pexchangetype = this.reviewInfo.pexchangetype
            model.projectid = this.reviewInfo.pexchangeprojectid
            model.pexchangeprojectid = this.reviewInfo.pexchangeprojectid
            model.pexchangepexpertid = this.reviewInfo.pexchangepexpertid
            model.pexchangestatus = this.reviewInfo.pexchangestatus
            model.pexchangeuserid = this.$store.getters.loginUser.userid
            model.pexchangeopinion = this.reviewInfo.pexchangeopinion
            model.pexchangeid = this.pexchangeid
            let res = await request({
                method: 'post',
                url: 'xmgl/project/submitReview',
                data: model
            })
            if(+res.issuccess === 2){
                this.$message.warning('项目已会签，不可审核')
                return
            }
            if(+res.issuccess === 1){
                this.$message.success('审核成功')
                this.close()
                return
            }
        },
        close () {
            this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
        },
    }
  }
</script>

<style lang="scss" scoped>
</style>
